// README:
// We might extends this functionality to support more generic use case
// Including the customers should be able to control which field will be used and validated
// This can be achieved by tracking the block list of the field
// Field can go to the block list with the following requirements
// 1. It should have default value or optional value in the database
// 2. The customer can't change the validation of the field

import React, { useEffect, useState } from 'react';

import {
  Grid,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Alert
} from "@mui/material";

interface PreviewProps {
  header: any[]
  rows: any[]
  destinationField?: any[]
  setColumnMap: React.Dispatch<React.SetStateAction<Map<string, string | null>>>
  columnMap: Map<string, string | null>
  destinationFieldRequired: string[]
}

export function ColumnMapping({
  destinationField,
  header,
  rows,
  setColumnMap,
  columnMap,
  destinationFieldRequired,
}: PreviewProps) {
  const [availableFieldOptions, setAvaialbleFieldOptions] = useState<any[] | undefined>([])
  const headerElement: JSX.Element[] = []

  useEffect(() => {
    Array.from(columnMap.keys()).map((e) => {
      if (!header.includes(e)) {
        columnMap.set(e, null)
      }
    })
  }, [header])

  const updateOption = () => {
    setAvaialbleFieldOptions(() => {
      const style = {
        padding: '5px',
        paddingLeft: '10px',
        fontSize: '1rem'
      }
      const temp = destinationField?.map((item: any, idx: any) => <MenuItem disabled={
        !!Array.from(columnMap.values()).find(value => {
          return value === item
        })
      } style={style} key={idx + 1} tabIndex={idx + 1
      } value={item} > {destinationFieldRequired.includes(item) ? `${item}*` : item}</MenuItem >)

      const noneOption = <MenuItem key={0} style={style} tabIndex={0} value={"empty"}>None</MenuItem>
      return temp ? [noneOption, ...temp] : [noneOption]
    })
  }

  useEffect(() => updateOption(), [
    columnMap,
    setColumnMap
  ])


  const handleColumnMap = (fileField: string) => {
    return (e: any) => {
      const value = e.target.value
      setColumnMap((prev: Map<string, string | null>) => {
        if (value === "empty") {
          prev.set(fileField.toLowerCase(), null)
        } else {
          prev.set(fileField.toLowerCase(), e.target.value)
        }
        return prev
      })
      updateOption()
    }
  }

  header.forEach((item: any) => {
    const mappedField = columnMap.get(item.toLowerCase())
    headerElement.push(<TableCell key={item} sx={{
      whiteSpace: 'nowrap'
    }}>
      <Grid container flexDirection="column" spacing={2}>
        {availableFieldOptions && item.toLowerCase() !== "no" &&
          <Grid item>
            <TextField
              sx={{
                padding: '2px', minWidth: '120px',
                '& .MuiInputBase-inputSizeSmall': {
                  padding: '5px',
                },
              }}
              value={destinationField?.includes(mappedField) ? mappedField : "empty"}
              select fullWidth size="small"
              onChange={handleColumnMap(item)}
            >
              {...availableFieldOptions}
            </TextField>
          </Grid>}
        <Grid item sx={{ textAlign: 'center' }}>
          {item}
        </Grid>
      </Grid>
    </TableCell>)
  })

  const rowElement: JSX.Element[] = []
  rows.forEach((row: any) => {
    const cells = row.map((item: any) => <TableCell key={item}>{
      item instanceof Date ? item.toLocaleDateString() :
        item === true ?
          'TRUE' :
          item === false ?
            'FALSE'
            : item
    }</TableCell>)
    rowElement.push(<TableRow>
      {cells}
    </TableRow>)
  })

  return <>
    <Alert severity="info">
      Please map the relevant fields to import data. Refer to the sample data below.
    </Alert>
    <Table sx={{ maxWidth: "1300px !important", maxHeight: "500px !important", display: "block", overflow: "auto" }}>
      <TableHead>
        <TableRow>
          {headerElement}
        </TableRow>
      </TableHead>
      <TableBody>
        {rowElement}
      </TableBody>
    </Table>
  </>
}
